import React, { Component } from 'react';
import styled, { css } from 'styled-components';

import BaseButton from '../../common/BaseButton';

class SubmitButton extends Component {
    constructor() {
        super();
        this.state = {
            isSending: false,
            width: 0,
        };

        this.handleClick = this.handleClick.bind(this);
        this.increaseWidth = this.increaseWidth.bind(this);
    }

    increaseWidth() {
        const { onClick } = this.props;
        const { width } = this.state;

        if (width < 100) {
            this.setState({ width: width + 5 });
            window.requestAnimationFrame(this.increaseWidth);
        } else {
            this.setState({ width: 100 });
            onClick();
        }
    }

    handleClick() {
        const { isActive } = this.props;

        if (isActive) {
            this.setState({ isSending: true });
            window.requestAnimationFrame(this.increaseWidth);
        }
    }


    render() {
        const { className, isActive } = this.props;
        const { width, isSending } = this.state;

        return (
            <Root className={className} onClick={this.handleClick} isActive={isActive}>
                <Button isSending={isSending} isActive={isActive}>
                    отправить
                </Button>
                <SendAnimation isSending={isSending}>
                    <Text>
                        отправка...
                    </Text>
                    <ColorBlock widthElement={width} />
                </SendAnimation>
            </Root>
        );
    }
}

const Root = styled(BaseButton)`
    width: 100%;
    height: 63px;

    cursor: ${({ isActive }) => (isActive ? 'pointer' : 'default')};
`;

const Button = styled.div`
    width: 100%;
    height: 63px;
    display: ${({ isSending }) => (isSending ? 'none' : 'flex')};
    justify-content: center;
    align-items: center;

    background: rgba(0, 0, 0, .1);
    color: rgba(0, 0, 0, .24);

    ${({ isActive }) => isActive && css`
        background: #000000;
        color: #FFFFFF;
    `}

    text-transform: uppercase;

    ${({ isActive }) => isActive && css`
        :hover {
            background: #0032A0;
        }

        :active {
            background: #002679;
        }
    `}
`;

const SendAnimation = styled(Button)`
    width: 100%;
    height: 63px;

    position: relative;

    display: ${({ isSending }) => (isSending ? 'block' : 'none')};
    text-align: center;

    background: #000000;
    color: #FFFFFF;
`;

const Text = styled.div`
    width: 100%;
    height: 63px;

    position: absolute;
    top: 30%;

    z-index: 1;
`;

const ColorBlock = styled.div`
    width: ${({ widthElement }) => (widthElement)}%;
    height: 63px;

    position: absolute;
    left: 0px;
    bottom: 0;

    background: #0032A0;
`;

export default SubmitButton;
